export enum InvoiceStatus {
  NEW = 'NEW',
  DRAFT = 'DRAFT',
  FINAL = 'FINAL',
  CANCELLED = 'CANCELLED',
}
